// extracted by mini-css-extract-plugin
export var postSidebar = "style-module--post-sidebar--f6162";
export var postSidebarBottom = "style-module--post-sidebar--bottom--54b5b";
export var postSidebarFixed = "style-module--post-sidebar--fixed--79452";
export var postSidebar__link = "style-module--post-sidebar__link--84ada";
export var postSidebar__linkActive = "style-module--post-sidebar__link--active--93c83";
export var postSidebar__links = "style-module--post-sidebar__links--717b3";
export var postSidebar__title = "style-module--post-sidebar__title--8ad89";